var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isOpenInvoiceCreateDialog,
        title: _vm.dialogTitle,
        width: "80%",
        "before-close": _vm.handleClose,
        top: "5vh",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpenInvoiceCreateDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "invoice-page" },
        [
          _c(
            "el-row",
            { staticClass: "top-row-flex", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v("THÔNG TIN KHÁCH HÀNG")])]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "customerForm",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-width": "150px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.form.buyerNotGetInvoice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "buyerNotGetInvoice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.buyerNotGetInvoice",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Người mua không lấy hóa đơn\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.form.paymentStatus,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "paymentStatus",
                                                $$v
                                              )
                                            },
                                            expression: "form.paymentStatus",
                                          },
                                        },
                                        [_vm._v("Người mua đã thanh toán")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 15 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Tên người mua",
                                        prop: "buyerName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerName,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "buyerName", $$v)
                                          },
                                          expression: "form.buyerName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Mã người mua" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerCode,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "buyerCode", $$v)
                                          },
                                          expression: "form.buyerCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Địa chỉ",
                                prop: "buyerAddressLine",
                                required: true,
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.buyerAddressLine,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "buyerAddressLine", $$v)
                                  },
                                  expression: "form.buyerAddressLine",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Tên đơn vị",
                                prop: "buyerLegalName",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.buyerLegalName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "buyerLegalName", $$v)
                                  },
                                  expression: "form.buyerLegalName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Mã số thuế",
                                        prop: "buyerTaxCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerTaxCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "buyerTaxCode",
                                              $$v
                                            )
                                          },
                                          expression: "form.buyerTaxCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Hợp đồng số" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.contractNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "contractNo",
                                              $$v
                                            )
                                          },
                                          expression: "form.contractNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Số điện thoại" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerPhoneNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "buyerPhoneNumber",
                                              $$v
                                            )
                                          },
                                          expression: "form.buyerPhoneNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Email" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerEmail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "buyerEmail",
                                              $$v
                                            )
                                          },
                                          expression: "form.buyerEmail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Loại giấy tờ" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.form.buyerIdType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "buyerIdType",
                                                $$v
                                              )
                                            },
                                            expression: "form.buyerIdType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "CCCD",
                                              value: "1",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "Hộ chiếu",
                                              value: "3",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Số giấy tờ",
                                        prop: "buyerIdNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerIdNo,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "buyerIdNo", $$v)
                                          },
                                          expression: "form.buyerIdNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Tên ngân hàng" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerBankName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "buyerBankName",
                                              $$v
                                            )
                                          },
                                          expression: "form.buyerBankName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Số tài khoản" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.buyerBankAccount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "buyerBankAccount",
                                              $$v
                                            )
                                          },
                                          expression: "form.buyerBankAccount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Mã ĐVQH ngân sách" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.buyerBudgetCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "buyerBudgetCode", $$v)
                                  },
                                  expression: "form.buyerBudgetCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("span", [_vm._v("THÔNG TIN HÓA ĐƠN")])]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "invoiceForm",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-width": "150px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Hình thức TT",
                                        prop: "paymentMethod",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          on: {
                                            change: _vm.onPaymentMethodChange,
                                          },
                                          model: {
                                            value: _vm.form.paymentMethod,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "paymentMethod",
                                                $$v
                                              )
                                            },
                                            expression: "form.paymentMethod",
                                          },
                                        },
                                        _vm._l(
                                          _vm.paymentMethods,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Chi tiết hình thức",
                                        prop: "paymentMethodName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            _vm.form.paymentMethod !== "5",
                                          placeholder:
                                            "Nhập hình thức thanh toán khác",
                                        },
                                        model: {
                                          value: _vm.form.paymentMethodName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "paymentMethodName",
                                              $$v
                                            )
                                          },
                                          expression: "form.paymentMethodName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Loại tiền",
                                        prop: "currencyCode",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value: _vm.form.currencyCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "currencyCode",
                                                $$v
                                              )
                                            },
                                            expression: "form.currencyCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.currencyOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item,
                                              attrs: {
                                                label: item,
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Tỷ giá",
                                        prop: "exchangeRate",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            _vm.form.currencyCode === "VND",
                                        },
                                        model: {
                                          value: _vm.form.exchangeRate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "exchangeRate",
                                              $$v
                                            )
                                          },
                                          expression: "form.exchangeRate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Mẫu hóa đơn",
                                prop: "templateCode",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { filterable: "" },
                                  on: { change: _vm.onInvoiceTemplateChange },
                                  model: {
                                    value: _vm.form.templateCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "templateCode", $$v)
                                    },
                                    expression: "form.templateCode",
                                  },
                                },
                                _vm._l(
                                  _vm.invoiceTemplateOptions,
                                  function (opt) {
                                    return _c("el-option", {
                                      key: opt.value,
                                      attrs: {
                                        label: opt.label,
                                        value: opt.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Ký hiệu hóa đơn",
                                prop: "invoiceSeries",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.form.invoiceSeries,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceSeries", $$v)
                                    },
                                    expression: "form.invoiceSeries",
                                  },
                                },
                                _vm._l(
                                  _vm.invoiceSeriesOptions,
                                  function (opt) {
                                    return _c("el-option", {
                                      key: opt.value,
                                      attrs: {
                                        label: opt.label,
                                        value: opt.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Ngày lập", prop: "invoiceDate" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "datetime" },
                                model: {
                                  value: _vm.form.invoiceDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "invoiceDate", $$v)
                                  },
                                  expression: "form.invoiceDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Ghi chú" } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 6 },
                                model: {
                                  value: _vm.form.invoiceNote,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "invoiceNote", $$v)
                                  },
                                  expression: "form.invoiceNote",
                                },
                              }),
                              _c("div", { staticClass: "invoice-warning" }, [
                                _c("div", [
                                  _vm._v(
                                    "1. Toàn bộ hóa đơn khi lưu nháp sẽ được lưu lại vào hệ thống bên phía OneKids để tiện cho việc chỉnh sửa sau này."
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.templateCode !== ""
            ? _c(
                "el-card",
                { staticClass: "box-card mt20" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "invoice-detail-header" },
                        [
                          _c("span", [_vm._v("CHI TIẾT HÓA ĐƠN")]),
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Dùng hàng hóa, dịch vụ mẫu",
                            },
                            on: { change: _vm.handleGoodsTemplateToggle },
                            model: {
                              value: _vm.enableGoodsTemplateSelection,
                              callback: function ($$v) {
                                _vm.enableGoodsTemplateSelection = $$v
                              },
                              expression: "enableGoodsTemplateSelection",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-table",
                    { attrs: { border: "", data: _vm.items } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "STT", width: "60", fixed: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.computeVisibleIndex(row)) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2983137973
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tính chất", width: "250", fixed: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      on: {
                                        change: function ($event) {
                                          return _vm.onSelectionChange(row)
                                        },
                                      },
                                      model: {
                                        value: row.selection,
                                        callback: function ($$v) {
                                          _vm.$set(row, "selection", $$v)
                                        },
                                        expression: "row.selection",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "Hàng hóa, dịch vụ",
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Ghi chú/diễn giải",
                                          value: 2,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Chiết khấu",
                                          value: 3,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "Phí khác", value: 4 },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Khuyến mại",
                                          value: 5,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          230999863
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Hàng hóa, dịch vụ",
                          "min-width": "320",
                          fixed: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "product-cell" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: !row.allowProduct,
                                            filterable: "",
                                            "allow-create": "",
                                            "default-first-option": "",
                                            "popper-class":
                                              "product-option-popper",
                                            placeholder:
                                              _vm.getProductPlaceholder(row),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onProductChange(row)
                                            },
                                          },
                                          model: {
                                            value: row.itemName,
                                            callback: function ($$v) {
                                              _vm.$set(row, "itemName", $$v)
                                            },
                                            expression: "row.itemName",
                                          },
                                        },
                                        _vm._l(
                                          _vm.productOptions,
                                          function (item) {
                                            return _c(
                                              "el-option",
                                              {
                                                key: item.code || item.name,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.name,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "product-option-wrap",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "product-option-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(item.name) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "product-option-meta",
                                                      },
                                                      [
                                                        _vm.getProductOptionCode(
                                                          item
                                                        )
                                                          ? [
                                                              _vm._v(
                                                                "\n                        Mã: " +
                                                                  _vm._s(
                                                                    _vm.getProductOptionCode(
                                                                      item
                                                                    )
                                                                  ) +
                                                                  " -\n                      "
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                      Đơn giá: " +
                                                            _vm._s(
                                                              _vm.formatProductOptionMeta(
                                                                item
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4152934115
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Đơn vị tính", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: !row.allowUnitName,
                                        filterable: "",
                                        "allow-create": "",
                                        "default-first-option": "",
                                        placeholder: "--Chọn đơn vị--",
                                        size: "mini",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onUnitNameChange(row)
                                        },
                                      },
                                      model: {
                                        value: row.unitName,
                                        callback: function ($$v) {
                                          _vm.$set(row, "unitName", $$v)
                                        },
                                        expression: "row.unitName",
                                      },
                                    },
                                    _vm._l(_vm.unitOptions, function (u) {
                                      return _c("el-option", {
                                        key: u,
                                        attrs: { label: u, value: u },
                                      })
                                    }),
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2301908328
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _vm._v(" Số lượng "),
                                  _c(
                                    "span",
                                    { staticClass: "required-asterisk" },
                                    [_vm._v("*")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    staticClass: "quantity-input",
                                    attrs: {
                                      disabled: !scope.row.allowQuantity,
                                      size: "mini",
                                      placeholder: "0",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.onQuantityBlur(scope.row)
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.onQuantityBlur(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.quantityDisplay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "quantityDisplay",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.quantityDisplay",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2358883780
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _vm._v(" Đơn giá "),
                                  _c(
                                    "span",
                                    { staticClass: "required-asterisk" },
                                    [_vm._v("*")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    staticClass: "numeric-input",
                                    attrs: {
                                      disabled: !scope.row.allowUnitPrice,
                                      size: "mini",
                                      placeholder: "0",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.onUnitPriceBlur(scope.row)
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.onUnitPriceBlur(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.unitPriceDisplay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "unitPriceDisplay",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.unitPriceDisplay",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4286047600
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { width: "160", align: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _vm._v(" Thành tiền "),
                                  _c(
                                    "span",
                                    { staticClass: "required-asterisk" },
                                    [_vm._v("*")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    staticClass: "numeric-input",
                                    attrs: {
                                      disabled: !scope.row.allowTotalAmount,
                                      size: "mini",
                                      placeholder: "0",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.onTotalAmountBlur(scope.row)
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.onTotalAmountBlur(scope.row)
                                      },
                                    },
                                    model: {
                                      value:
                                        scope.row
                                          .itemTotalAmountWithoutTaxDisplay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "itemTotalAmountWithoutTaxDisplay",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.itemTotalAmountWithoutTaxDisplay",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2585516188
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tiền thuế", width: "320" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "tax-cell" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "110px" },
                                          attrs: {
                                            disabled: !row.allowTax,
                                            filterable: "",
                                            placeholder: "--Lựa chọn--",
                                            size: "mini",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onTaxPercentageChange(
                                                row
                                              )
                                            },
                                          },
                                          model: {
                                            value: row.taxPercentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row,
                                                "taxPercentage",
                                                $$v
                                              )
                                            },
                                            expression: "row.taxPercentage",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "Khác",
                                              value: "other",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "Không chịu thuế",
                                              value: -2,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "Không kê khai",
                                              value: -1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "0%", value: 0 },
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "5%", value: 5 },
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "8%", value: 8 },
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "10%", value: 10 },
                                          }),
                                        ],
                                        1
                                      ),
                                      String(row.taxPercentage) === "other"
                                        ? _c("el-input", {
                                            staticStyle: {
                                              width: "90px",
                                              "margin-left": "4px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              placeholder: "%",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.onCustomTaxInputBlur(
                                                  row
                                                )
                                              },
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.onCustomTaxInputBlur(
                                                  row
                                                )
                                              },
                                            },
                                            model: {
                                              value: row.taxPercentageInput,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row,
                                                  "taxPercentageInput",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.taxPercentageInput",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("span", { staticClass: "tax-equal" }, [
                                        _vm._v("="),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(row.taxAmount)
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4289123933
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Hành động",
                          width: "120",
                          align: "center",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ $index }) {
                                return [
                                  _c("el-button", {
                                    attrs: {
                                      icon: "el-icon-delete",
                                      type: "danger",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeRow($index)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2626333017
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "add-row" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", icon: "el-icon-plus" },
                          on: { click: _vm.addRow },
                        },
                        [_vm._v("\n          Thêm\n        ")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "invoice-total" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("span", [_vm._v("Tổng tiền hàng")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.formatCurrency(_vm.subtotal))),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("span", [_vm._v("Tổng tiền trước thuế")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.formatCurrency(_vm.totalBeforeTax))),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("span", [_vm._v("Tiền thuế")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.formatCurrency(_vm.lineTaxTotal))),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("span", [_vm._v("Tổng tiền sau thuế")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.formatCurrency(_vm.totalAfterTax))),
                      ]),
                    ]),
                    _c("div", { staticClass: "row total" }, [
                      _c("span", [_vm._v("Tổng tiền thanh toán")]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatCurrencyByCode(
                              _vm.grandTotal,
                              _vm.form.currencyCode
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row words" }, [
                      _c("span", [_vm._v("Số tiền bằng chữ")]),
                      _c("em", [_vm._v(_vm._s(_vm.totalInWordsCurrency))]),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.handleBack } },
            [_vm._v("Quay lại")]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.handleClearInput } },
            [_vm._v("Xóa dữ liệu nhập")]
          ),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.actionLoading.preview, type: "warning" },
              on: { click: _vm.handlePreviewInvoice },
            },
            [_vm._v("Xem trước nháp")]
          ),
          _vm.checkPermission(["electronic-invoice-create-draft"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "warning", loading: _vm.actionLoading.draft },
                  on: { click: _vm.handleSaveServerDraftInvoice },
                },
                [_vm._v("Lưu nháp")]
              )
            : _vm._e(),
          _vm.checkPermission(["electronic-invoice-create-issued"]) &&
          _vm.isCreateInvoice === true &&
          _vm.getSinvoiceConfigField("usbDigitalSignature", false) === false
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.actionLoading.final },
                  on: { click: _vm.handleCreateInvoice },
                },
                [_vm._v("Phát hành HĐ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xem trước hóa đơn",
            visible: _vm.previewDialogVisible,
            width: "90%",
            "custom-class": "preview-dialog-no-limit",
            "append-to-body": "",
            top: "1vh",
            "before-close": _vm.handlePreviewDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _vm.previewPdfUrl
            ? _c("div", { staticClass: "preview-pdf-wrapper" }, [
                _c("iframe", {
                  staticClass: "preview-pdf-iframe",
                  attrs: { src: _vm.previewPdfUrl },
                }),
              ])
            : _c("div", [
                _c("pre", { staticClass: "preview-json" }, [
                  _vm._v(_vm._s(_vm.previewPayloadText)),
                ]),
              ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.checkPermission(["electronic-invoice-create-draft"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.actionLoading.save,
                      },
                      on: { click: _vm.handleSaveServerDraftInvoice },
                    },
                    [_vm._v("Lưu nháp")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.previewDialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xác nhận",
            visible: _vm.confirmIssueDialogVisible,
            width: "420px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmIssueDialogVisible = $event
            },
          },
        },
        [
          _c("div", [_vm._v("Bạn có chắc chắn muốn lập hóa đơn không?")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmIssueDialogVisible = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmIssue },
                },
                [_vm._v("Đồng ý")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xác nhận",
            visible: _vm.confirmDraftDialogVisible,
            width: "420px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmDraftDialogVisible = $event
            },
          },
        },
        [
          _c("div", [_vm._v("Bạn có chắc chắn muốn lập hóa đơn nháp không?")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmDraftDialogVisible = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.actionLoading.draft },
                  on: { click: _vm.handleConfirmCreateDraftInvoice },
                },
                [_vm._v("\n      Đồng ý\n    ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }